import { defineSlotRecipe } from '@chakra-ui/react';

export const mapEntryPointSlotRecipe = defineSlotRecipe({
    slots: ['container', 'image', 'button'],
    base: {
        container: {
            display: 'grid',
            placeItems: 'center',
            borderRadius: 'lg',
            overflow: 'hidden',
            position: 'relative',
            w: '100%',
            mb: 5,
        },
        image: {
            gridArea: '1 / 1',
            pointerEvents: 'none',
        },
        button: {
            gridArea: '1 / 1',
            position: 'relative',
            colorPalette: 'secondary',
        },
    },
});
